/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@font-face{font-family:MyriadPro;font-weight:300;src:url(/assets/fonts/merriweather.ttf) format(\"truetype\")}@font-face{font-family:MyriadPro;font-weight:400;src:url(/assets/fonts/merriweather.ttf) format(\"truetype\")}@media (max-width:959px){  .mat-raised-button{min-width:100%!important;margin:5px!important}}"];
export { styles as styles };
